import type { Meta, StoryFn } from '@storybook/react';
import type { FieldHintProps } from './FieldHint';

import { FieldHint } from './FieldHint';

const codeString = '<FieldHint value={value} loading={loading} spinnerAriaValueText={spinnerAriaValueText} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/FieldHint',
  component: FieldHint,
  argTypes: {
    value: {
      control: 'text',
    },
    spinnerAriaValueText: {
      control: 'text',
    },
  },
  parameters: {
    inspectComponent: FieldHint,
    codeString: codeString,
  },
} as Meta<FieldHintProps>;

const Template: StoryFn<FieldHintProps> = (args) => <FieldHint {...args} />;

const defaultArgs: Partial<FieldHintProps> = {
  spinnerAriaValueText: 'FieldHint Loading',
};

export const FieldHintExample = Template.bind({});
FieldHintExample.args = {
  value: 'This is a FieldHint',
  loading: false,
  ...defaultArgs,
};

export const LoadingFieldHint = Template.bind({});
LoadingFieldHint.args = {
  value: '',
  loading: true,
  ...defaultArgs,
};
